import { Component, OnInit, Input, Inject, ViewChild } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from '../status/status-constant';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { AddQuestionTempCategoryComponent } from '../addQuesTempCategory/addQuesTempCategory.component';
import { AddQualifyingTempCategoryComponent } from '../addQualifyingTempCategory/addQualifyingTempCategory.component';
import { LoaderService } from '../../shared/loader/loader.service';

@Component({
  selector: 'app-importautomationTemplate',
  templateUrl: './importautomationTemplate.component.html',
  styleUrls: ['./importautomationTemplate.component.scss'] 
})

export class ImportAutomationTemplateComponent implements OnInit {

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  OfficeIDList: any=[];
  myOfficeID: any; 
  spinner:boolean=false;

 
  filteredTaskCategoryList: any = ([] = []);
  ShowNoRecordFoundTaskTemplates: Boolean = false;
  taslTemplateID: number = 0;
  showSaveTemplate: Boolean = false;
  QuestionTemplateID: number = 0; 

  updateQuestionTemplateButton: boolean = false;
  selectedcategoryIDForQuestion: number = 0; 
 
  searchTemplateQuestion: string = '';
  categoryType: number = 0;

  timeout = null;

  rolesAsssign:any=[]=[];


  officeIdForImportPromptTemp: number = 0;
  organizationIdForImportPromptTemp: number = 0;
  templateIDImportTask: number = 0;
  newQuestionsTOUpdate:any=[]=[];
  queryBlocks:any=[]=[];
  ShowNoRecordFoundQuestionTemplate: boolean = false;
  NLPTemplatesList:any=[]=[];
  currentIndex: number = 0;
  selectedTemplate: any = ([] = []);
  filteredTempCategoryList: any = ([] = []);
  searchTemplateName: string = '';
  ShowNoRecordFoundTemplates: boolean = false;
  ImportTemplatesList: any = ([] = []);
  TemplateIDImportTask: number = 0;
  selectedcategoryIDForImportTemp: number = 0;
  showImportTemplate: boolean = false;
  filteredQualifyingCategoryList: any = ([] = []);
  QualifyingCategoryList: any = ([] = []);
  QualifyingTemplatesList: any = ([] = []);
  QualifyingTemplatesListFilter: any = ([] = []);
  templateID: number = 0;
  totalRules:number=0;
  taskListIDforImportTask:number=0;
  selectedTaskCategoryID:number=0;
  transactionIDForTask:number=0;
  typeIdForTask:number=0;
  categoryTypeForSingleTask:number=0;
  TaskTemplatesListForSingleTask:any=[]=[];
  TaskTemplatesListForSingleTaskFilter:any=[]=[];
  ShowNoRecordFound:boolean=false;
  taskCategoryList:any=[]=[];
  taskTemplateIDForSingleTask:number=0;

  // attach details of the record the automation gallery was opened from
  entityId:number=0;
  entityTypeID:number=0;
  cTypeForTask:number=0;
  name:string='';
  email:string='';
  AttachChecked:boolean=false;
  AssigneeChecked:boolean=false;
  NotifyChecked:boolean=true;

  constructor(private dialog: MatDialog,private dialog1: MatDialog,private datePipe: DatePipe, public dialogRef: MatDialogRef<ImportAutomationTemplateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private settingsService: SettingService, private statusConst: StatusConstant,
    private coreService: CoreService, private toastr: ToastrService,private loaderService: LoaderService, ) {  
     
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    if(encryptedtoken!=null){
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);   
      this.currentUser = jwt_decode(token); 
      var offices = JSON.parse(sessionStorage.getItem('officeList') ?? '[]');
      offices.forEach((oe:any) => {
      this.OfficeIDList.push(oe.officeID);
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
    }

    if (this.data != null && this.data != undefined) {
      this.transactionIDForTask = Number(this.data.transactionID) || 0;
      this.typeIdForTask = Number(this.data.typeId) || 0;
      this.cTypeForTask = Number(this.data.cType) || 0;
      this.taskListIDforImportTask = Number(this.data.taskListID) || 0;
      this.entityId = Number(this.data.entityID) || 0;
      this.entityTypeID = Number(this.data.entityTypeID) || 0;
      this.name = this.data.name ?? '';
      this.email = this.data.email ?? '';
    }
  }  
  
  ngOnInit(): void {     
   // this.AttachChecked = false;
   // this.AssigneeChecked = false;
  //  this.NotifyChecked = false;
    this.categoryTypeForSingleTask = 0;
    this.currentIndex = 0;
    this.selectedTemplate = [];
    this.getTaskTemplatesForSingleTask();
    this.selectedTaskCategoryID = 0;
    this.categoryType = 0;
    this.searchTemplateName = "";
    this.getActiveTaskTemplateCategories();
  }
     
  getTaskTemplatesForSingleTask() {
   this.ShowNoRecordFoundTaskTemplates = false;
   this.selectedTemplate = [];
   this.taskTemplateIDForSingleTask = 0;
   this.loaderService.show();
   var ReqModel = {
    folderID: Number(this.selectedTaskCategoryID),
    categoryID: Number(this.selectedTaskCategoryID),
    searchKey: "",
    type: Number(this.categoryTypeForSingleTask),
    userID: this.currentUser.UID,
    officeID: this.myOfficeID,
    organizationID: Number(this.organizationId),
    TemplateType: 1,
  }
  this.settingsService.getTaskTemplate(ReqModel).subscribe(response => {
    if (response != undefined) {
      this.responseHolder = response;
      this.loaderService.hide();
      if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
        // GetActiveTaskTemplates returns taskTemplateID / taskTemplateName,
        // the template list binds taskId / templateName.
        var templates = (this.responseHolder.data || []).map((item: any) => ({
          ...item,
          taskId: item.taskId != undefined ? item.taskId : item.taskTemplateID,
          templateName: item.templateName != undefined ? item.templateName : item.taskTemplateName
        }));
        this.TaskTemplatesListForSingleTask = templates;
        this.TaskTemplatesListForSingleTaskFilter = templates;
        if (this.TaskTemplatesListForSingleTask.length > 0) {
          this.ShowNoRecordFoundTaskTemplates = false;
        } else {
          this.ShowNoRecordFoundTaskTemplates = true;
        }
      }
      else {
        this.ShowNoRecordFoundTaskTemplates = true;
        this.TaskTemplatesListForSingleTask = [];
        this.loaderService.hide();
      }
    }
    else {
      this.TaskTemplatesListForSingleTask = [];
      this.ShowNoRecordFound = true;
      this.loaderService.hide();
    }
  });
}

 getActiveTaskTemplateCategories() {
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
    }
    this.settingsService.getActiveTaskTemplateCategories(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.taskCategoryList = response.data;
          this.filteredTaskCategoryList = this.taskCategoryList.filter((m:any) => m.type == this.categoryType);
        }
        else {
          this.taskCategoryList = [];
          this.filteredTaskCategoryList = [];
        }
      }
      else {
        this.taskCategoryList = [];
        this.filteredTaskCategoryList = [];
      }
    });
  }

   closeImportTaskTemplate() {
    this.selectedTemplate = [];
    this.taskTemplateIDForSingleTask = 0;
   // this.taskListFolderID = 0;
    this.taskListIDforImportTask = 0;
    this.selectedTaskCategoryID = 0;
    this.searchTemplateName = "";
    this.categoryType = 0;
    this.dialog.closeAll();
  }

   //Only one template can be imported at a time
  selectTemplate(template:any) {
    this.selectedTemplate = [template];
    this.taskTemplateIDForSingleTask = this.getTemplateID(template);
  }

   searchTemplateForSingleTask(val:any) {
    if (val.length >= 2) {
      if (val != '') {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.TaskTemplatesListForSingleTask = this.TaskTemplatesListForSingleTaskFilter.filter((i:any) => i.templateName.toLowerCase().indexOf(val.toLocaleLowerCase()) !== -1);
        }, 500);
      } else {

      }
    } else {
      this.searchTemplateName = "";
      this.getTaskTemplatesForSingleTask();
    }
  }

   getTaskListThroughCategoryForTaskImport(e: any, i: any) {
    this.selectedTemplate = [];
    this.currentIndex = i
    //his.categoryTypeForSingleTask = e;
    this.selectedTaskCategoryID = e;
    this.getTaskTemplatesForSingleTask();
  }

   onTaskListTabChangeForTaskImport($event:any) {
    this.selectedTaskCategoryID = 0;
    const textLabel = $event.value;
    const categoryValue = textLabel == 'My Template' ? 0 : textLabel == 'Organization' ? 2 : 1;
    this.categoryTypeForSingleTask = categoryValue;
    this.getTaskTemplatesForSingleTask();
  }

   getTemplateID(template: any) {
    if (template == null || template == undefined) {
      return 0;
    }
    return Number(template.taskTemplateID != undefined ? template.taskTemplateID : template.taskId) || 0;
  }

   async importTaskTemplates() {
    this.loaderService.show();
    var taskIdss = [];
    if (this.selectedTemplate.length > 0) {
      for (let i = 0; i < this.selectedTemplate.length; i++) {
        taskIdss.push(this.getTemplateID(this.selectedTemplate[i]));
      }
    }

    // the task list template the user picked in the gallery
    var taskListIDforImportTask = 0;
    if (this.selectedTemplate.length > 0) {
      taskListIDforImportTask = this.getTemplateID(this.selectedTemplate[0]);
    } else if (this.taskListIDforImportTask > 0) {
      taskListIDforImportTask = this.taskListIDforImportTask;
    }

    var ReqModel = {
      attachDetails: {
        entityID: Number(this.entityId),
        cType: Number(this.cTypeForTask),
        name: this.name,
        email: this.email,
        entityTypeID: Number(this.entityTypeID)
      },
      taskIds: taskIdss,
      taskListID: Number(taskListIDforImportTask),
      transaction: {
        transactionID: Number(this.transactionIDForTask),
        typeId: Number(this.typeIdForTask)
      },
      keepAttached: this.AttachChecked,
      keepAssignee: this.AssigneeChecked,
      keepNotify: this.NotifyChecked,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
      officeIDList: this.OfficeIDList,
    }
    // return;
    this.spinner = true;
    const result = await this.settingsService.importTaskFromTemplate(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner = false;
      this.loaderService.hide();
      this.toastr.success("Task Imported successfully.", '', {
        timeOut: 3000,
      });
     // this.getTaskList(this.pageModelData);
      this.selectedTemplate = [];
      this.dialogRef.close(true);
    }
    else {
      this.toastr.error("Task Import failed.", '', {
        timeOut: 3000,
      });
      this.spinner = false;
      this.loaderService.hide();
    }
  }
     
}
